export const stableId = (prefix: string, key: string) => `${prefix}:${key}`
